import { Form } from './form';

/**
 * Returns whether a form is an amendment rather than an original version.
 */
export function isFormAmendment(form: Pick<Form, 'previous_version'>): boolean {
  return form.previous_version !== null && form.previous_version !== undefined;
}

/**
 * Returns whether a form is a completed amendment rather than an original version.
 */
export function isCompletedFormAmendment(form: Pick<Form, 'previous_version' | 'status'>): boolean {
  return form.status === 5 && isFormAmendment(form);
}
